import React, { ReactElement } from 'react';
import { Typography } from '@mui/material';

// Icons
import { TipIcon } from './icons/TipIcon';
import { SearchIcon } from './icons/SearchIcon';

import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  icon?: ReactElement;
  title: string;
  description?: string;
  tip?: React.ReactNode;
}

/**
 * @HowToUse
 * <EmptyState
 *  title="Find a Resource to Begin"
 *  description="Select a Resource Type and enter a Resource ID to view event details and identify issues."
 *  tip={
 *    <span aria-label="tip-text">
 *      Need help finding a Resource ID? Check your Data Flows or ask your admin.
 *    </span>
 *  }
 * />
 */
export const EmptyState = (props: EmptyStateProps) => {
  const { icon = null, title, description, tip } = props;

  return (
    <div data-testid="empty-state-container" className={styles.container}>
      {icon || (
        <div className={styles.defaultIconContainer}>
          <SearchIcon className={styles.searchIcon} />
        </div>
      )}

      <span className={styles.title}>{title}</span>

      {description && (
        <Typography variant="body2" className={styles.description}>
          {description}
        </Typography>
      )}

      {tip && (
        <div className={styles.tipContainer}>
          <TipIcon />
          <span aria-label="tip-text">{tip}</span>
        </div>
      )}
    </div>
  );
};
